const pad2 = (n) => String(n).padStart(2, "0");

export const TIPOS_COMPLEMENTO = ["Casa", "Piso", "Apartamento"];
export const LETRAS_CASA = Array.from({ length: 26 }, (_, i) => String.fromCharCode(65 + i));
export const NUMEROS_CASA = Array.from({ length: 20 }, (_, i) => pad2(i + 1));
export const PISOS = Array.from({ length: 10 }, (_, i) => String(i + 1));
export const PISOS_APTO = Array.from({ length: 5 }, (_, i) => String(i + 1));
export const NUMEROS_APTO = NUMEROS_CASA;

const vacio = (v) => !v || v === "-";

// Une los campos elegidos en un solo texto: "Piso 3", "Casa B 05", "Apartamento 504".
export const armarComplemento = ({ tipo, letra, num, pisoApto }) => {
  if (tipo === "Piso") return vacio(num) ? "" : `Piso ${num}`;
  if (tipo === "Casa") {
    const partes = [letra, num].filter((v) => !vacio(v));
    return partes.length ? `Casa ${partes.join(" ")}` : "";
  }
  if (tipo === "Apartamento") {
    const apto = `${vacio(pisoApto) ? "" : pisoApto}${vacio(num) ? "" : num}`;
    return apto ? `Apartamento ${apto}` : "";
  }
  return "";
};

// Casa: basta con letra o número. Piso: número. Apartamento: ambos campos elegidos.
export const complementoCompleto = ({ tipo, letra, num, pisoApto }) => {
  if (!tipo) return true;
  if (tipo === "Piso") return !!num;
  if (tipo === "Casa") return !vacio(letra) || !vacio(num);
  if (tipo === "Apartamento") return !!pisoApto && !!num;
  return true;
};

// Separa "KR 96 # 45 - 15 Casa B 05" en dirección base y campos del complemento.
// Si no encuentra complemento, toda la dirección queda como base.
export const separarComplemento = (address = "") => {
  const texto = String(address).trim();
  const vacioRes = { base: texto, tipo: "", letra: "", num: "", pisoApto: "" };
  const match = texto.match(/^(.*?)\s+(Casa|Piso|Apartamento|Apto)\s+(.+)$/i);
  if (!match) return vacioRes;

  const base = match[1].trim();
  const resto = match[3].trim();
  const palabra = match[2].toLowerCase();

  if (palabra === "piso") {
    return /^\d{1,2}$/.test(resto) ? { ...vacioRes, base, tipo: "Piso", num: resto } : vacioRes;
  }
  if (palabra === "casa") {
    const m = resto.match(/^(?:([A-Za-z])\s*)?(\d{2})?$/);
    if (!m || (!m[1] && !m[2])) return vacioRes;
    return { ...vacioRes, base, tipo: "Casa", letra: (m[1] || "").toUpperCase(), num: m[2] || "" };
  }
  // Apartamento / Apto: 3 dígitos = piso + número; 2 dígitos = solo número; 1 dígito = solo piso.
  if (!/^\d{1,3}$/.test(resto)) return vacioRes;
  const pisoApto = resto.length === 3 ? resto[0] : resto.length === 1 ? resto : "";
  const num = resto.length === 3 ? resto.slice(1) : resto.length === 2 ? resto : "";
  return { ...vacioRes, base, tipo: "Apartamento", pisoApto, num };
};
